/* global $ */

import { Controller } from 'stimulus';

class AttendanceController extends Controller {
  onAccept() {
    this.updateAttendance(true);
    this.toggleQuestion(false);
  }

  onDeny() {
    this.updateAttendance(false);
    this.toggleQuestion(false);
  }

  toggleQuestion(state = false) {
    this.questionTarget[state ? 'removeAttribute' : 'setAttribute']('hidden', 'hidden');
    this.resultTarget[state ? 'setAttribute' : 'removeAttribute']('hidden', 'hidden');
  }

  updateAttendance(state) {
    const id = this.data.get('id');

    this.resultTextTarget.innerHTML = state ? this.data.get('yes-text') : this.data.get('no-text');

    $.ajax({
      url: '/api/agenda-attendance',
      type: 'POST',
      data: {
        id,
        state: state ? 1 : 0,
      },
    });
  }
}

AttendanceController.targets = [
  'question',
  'result',
  'resultText',
];

export default AttendanceController;
